import React, { Component } from 'react';
import Chart from 'react-apexcharts';

class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.chartData) !== JSON.stringify(this.props.chartData) ||
      JSON.stringify(prevProps.chartOptions) !== JSON.stringify(this.props.chartOptions)
    ) {
      this.setState({
        chartData: this.props.chartData,
        chartOptions: this.props.chartOptions,
      });
    }
  }

  render() {
    const height = this.props.height || 350;
    return (
      <div style={{ width: '100%', height: height, minHeight: height }}>
        <Chart
          options={this.state.chartOptions}
          series={this.state.chartData}
          type="bar"
          width="100%"
          height="100%"
        />
      </div>
    );
  }
}

export default BarChart;
